<template>
  <div class="containerTable">
    <el-row>
      <el-col :span="12">
        <div>
          <el-tree
            ref="tree"
            :props="props"
            :data="treeData"
            node-key="value"
            :expand-on-click-node="false"
            default-expand-all
          >
            <span
              slot-scope="{ node, data }"
              class="custom-tree-node"
              @click.stop.prevent="() => edit(data)"
            >
              <span>{{ node.label }}</span>
              <template v-if="isCtms">
                <span>
                  <el-button
                    v-if="dict_edit_button && data.level > 2"
                    size="mini"
                    type="text"
                    icon="el-icon-edit"
                    circle
                    @click="() => edit(data)"
                  />
                  <el-button
                    v-if="dict_add_button && data.level < 5"
                    size="mini"
                    type="text"
                    icon="el-icon-plus"
                    circle
                    @click="() => append(data)"
                  />
                  <el-button
                    v-if="dict_delete_button && data.level > 2"
                    size="mini"
                    type="text"
                    icon="el-icon-minus"
                    circle
                    @click="() => remove(node, data)"
                  />
                </span>
              </template>
              <template v-if="!isCtms">
                <span>
                  <el-button
                    v-if="dict_edit_button"
                    size="mini"
                    type="text"
                    icon="el-icon-edit"
                    circle
                    @click.stop.prevent="() => edit(data)"
                  />
                  <el-button
                    v-if="
                      (dict_add_button && data.level >= 3 && data.level < 5) ||
                        isSuperAdmin
                    "
                    size="mini"
                    type="text"
                    icon="el-icon-plus"
                    circle
                    @click.stop.prevent="() => append(data)"
                  />
                  <el-button
                    v-if="
                      (dict_delete_button && data.level > 3) || isSuperAdmin
                    "
                    size="mini"
                    type="text"
                    icon="el-icon-minus"
                    circle
                    @click.stop.prevent="() => remove(node, data)"
                  />
                </span>
              </template>
            </span>
          </el-tree>
        </div>
      </el-col>
      <el-col :span="12"></el-col>
      <el-col
        :span="6"
        style="position: fixed;right: 30px;top:150px;background-color: #fff;padding: 20px;box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);"
      >
        <div style="padding: 10px;">
          <el-form ref="form" :rules="rules" :model="form" label-width="80px">
            <el-row>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <el-form-item label="父类名称:" style="margin-right:15px">
                    {{ form.parentName }}
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <el-form-item
                    label="名称"
                    prop="name"
                    style="margin-right:15px"
                  >
                    <el-input v-model="form.name" placeholder="请输入名称" />
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <el-form-item
                    label="编码"
                    prop="code"
                    style="margin-right:15px"
                  >
                    <el-input
                      v-model="form.code"
                      :disabled="!(isSuperAdmin || form.id == '')"
                      placeholder="请输入编码"
                    />
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <el-form-item
                    label="标准编码"
                    prop="dealerCode"
                    style="margin-right:15px"
                  >
                    <el-input
                      v-model="form.dealerCode"
                      :disabled="!(isSuperAdmin || form.id == '')"
                      placeholder="请输入编码"
                    />
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <el-form-item
                    label="显示顺序"
                    prop="sort"
                    style="margin-right:15px"
                  >
                    <el-input
                      v-model="form.sort"
                      placeholder="请输入显示顺序"
                      @input="
                        value =>
                          formFormatter.isInteger(value, oldValue, form, 'sort')
                      "
                    />
                  </el-form-item>
                </div>
              </el-col>
              <el-col v-if="hasDensity && loginkTarget == 'hebei'" :span="24">
                <div class="grid-content bg-purple">
                  <el-form-item
                    label="密度比"
                    prop="densityRatio"
                    style="margin-right:15px"
                  >
                    <el-input
                      v-model="form.densityRatio"
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="请输入密度比"
                      @change="value => setNamber(value, 'densityRatio')"
                    />
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              v-if="getLimit('dict_add_button')"
              type="primary"
              @click="funcSubmit"
            >
              确 定
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { is4ABCorNum } from "@/utils/validate4Form";
import request from "@/utils/request";
import { getRole } from "@/utils/getRole";
export default {
  name: "GoodsTypeList",
  components: {},
  data() {
    return {
      isCtms: false, //是否为同城系统，默认否
      isSuperAdmin: false,
      message: "",
      loginkTarget: "",
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      copy: false,
      hasDensity: false,
      treeData: [],
      props: {
        label: "label",
        children: "children"
      },
      form: {
        id: "",
        code: "",
        dealerCode: "",
        name: "",
        level: "",
        parentCode: "",
        sort: "",
        densityRatio: ""
      },
      oldNodeVal: "",
      rules: {
        code: [
          { required: true, message: "请输入编码", trigger: "blur" },
          { validator: this.validCode, trigger: "blur" }
        ],
        dealerCode: [
          { required: true, message: "请输入标准编码", trigger: "blur" },
          { validator: this.validCode, trigger: "blur" }
        ],
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
        ],
        sort: [{ required: true, message: "请输入显示顺序", trigger: "blur" }],
        densityRatio: [
          { required: true, message: "请输入密度比", trigger: "blur" },
          { max: 10, message: "不超过10个字符", trigger: "blur" }
        ]
      },
      dict_search_button: false,
      dict_add_button: false,
      dict_edit_button: false,
      dict_delete_button: false
    };
  },
  watch: {
    "form.level": {
      handler: function(val) {
        if (val == 3) {
          this.rules.code = [
            { required: true, message: "请输入编码", trigger: "blur" },
            { validator: is4ABCorNum, trigger: "blur" },
            { validator: this.validCode, trigger: "blur" }
          ];
        } else {
          this.rules.code = [
            { required: true, message: "请输入编码", trigger: "blur" },
            { validator: this.validCode, trigger: "blur" }
          ];
        }
      }
    }
  },
  created() {
    const partyType = this.$store.getters.party.partyType;
    this.isSuperAdmin = partyType == "SUPER_ADMIN";
    this.loadTreeData();
    this.isCtms = getRole(); //用户登录的是同城系统返回true
    // this.loginkTarget = JSON.parse(
    //   localStorage.getItem('dataBranch')
    // ).partyGroupConfigCacheMap.loginkTarget_reportProvince.configValue
    this.loginkTarget = this.reportProvince();
    this.dict_search_button = this.getLimit("dict_search_button");
    this.dict_add_button = this.getLimit("dict_add_button");
    this.dict_edit_button = this.getLimit("dict_edit_button");
    this.dict_delete_button = this.getLimit("dict_delete_button");
  },
  methods: {
    // 设置密度比
    setNamber(value, key) {
      if (value < 0) {
        this.$set(this.form, key, 0);
      } else {
        this.$set(
          this.form,
          key,
          value.replace(/([0-9]+\.[0-9]{2})[0-9]*/, "$1")
        );
      }
    },
    loadTreeData() {
      request({
        url: "/ntocc-basic-api/goodsType/queryTreeData",
        method: "get"
      }).then(response => {
        this.treeData = response.data;
      });
    },
    validCode(rule, value, callback) {
      this.getByCode(value, data => {
        if (data && this.form.id != data.id) {
          callback(new Error("商品编码已存在！"));
        } else {
          callback();
        }
      });
    },
    getByCode(code, backFun) {
      request({
        url: "/ntocc-basic-api/goodsType/" + code,
        method: "get"
      }).then(response => {
        backFun(response.data);
      });
    },
    append(data) {
      this.$refs.form.resetFields();
      this.hasDensity = data.level == 3;
      this.oldNodeVal = "";
      let parentNode = this.$refs.tree.getNode(data.value);
      this.form = {
        id: "",
        code: "",
        name: "",
        level: parentNode.level + 1,
        parentName: data.label,
        parentCode: data.value,
        sort: ""
      };
      if (data.children && data.children.length > 0) {
        let lastChild = data.children[data.children.length - 1];
        this.getByCode(lastChild.value, data => {
          this.form.sort = data.sort + 1;
        });
      } else {
        this.form.sort = 1;
      }
    },
    edit(data) {
      this.$refs.form.resetFields();
      this.oldNodeVal = data.value;
      this.hasDensity = data.level == 3;
      this.getByCode(data.value, res => {
        if (res) {
          this.form = res;
          let parentNode = this.$refs.tree.getNode(this.form.parentCode);
          this.form.parentName = parentNode.label;
        } else {
          this.$message({ message: "获取商品类型失败！", type: "error" });
        }
      });
    },
    remove(node, data) {
      if (node.isLeaf) {
        this.$confirm(`确认删除【${data.label}】吗？`)
          .then(_ => {
            request({
              url: `/ntocc-basic-api/goodsType`,
              method: "delete",
              params: { codes: data.value }
            })
              .then(response => {
                this.$message({ message: response.msg, type: "success" });
                const parent = node.parent;
                const children = parent.data.children || parent.data;
                const index = children.findIndex(d => d.value === data.value);
                children.splice(index, 1);
              })
              .then(() => this.$refs["form"].resetFields());
          })
          .catch(_ => {});
      } else {
        this.$message({ message: "请先删除子类型！", type: "error" });
      }
    },
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          let requestType = "post";
          if (data.id) {
            requestType = "put";
          }
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/goodsType",
            method: requestType,
            params: data
          })
            .then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              /*const parent = this.$refs.tree.getNode(this.form.parentCode);
              if (!parent.data.children) {
                this.$set(parent.data, 'children', []);
              }
              const children = parent.data.children;
              let newNode = {value:this.form.code,label:this.form.name}
              if(this.oldNodeVal!==''){
                const index = children.findIndex(d => d.value === this.oldNodeVal);
                children.splice(index, 1,newNode);
              }else{
                children.push(newNode);
              }*/
              this.loadTreeData();
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
